import { createAction } from 'redux-actions';
import axios from 'axios';
import CategoriesService from '../../services/CategoriesService';
export const FETCH_CATEGORIES_PENDING = createAction('FETCH_CATEGORIES_PENDING');
export const FETCH_CATEGORIES_SUCCESS = createAction('FETCH_CATEGORIES_SUCCESS');
export const FETCH_CATEGORIES_ERROR = createAction('FETCH_CATEGORIES_ERROR');


export const handleGetCategories = () => {
    return async (dispatch, getState) => {
        const cancelToken = axios.CancelToken.source();
        dispatch(FETCH_CATEGORIES_PENDING(cancelToken));
        try{
            const result = await CategoriesService.listCategories();                 
            dispatch(FETCH_CATEGORIES_SUCCESS(result.data));  
            localStorage.setItem('categories',  JSON.stringify(result.data));
        }catch (error) {
          const statusCode = error.response ? error.response.status : 0;
          if (statusCode === 404) {
            dispatch(FETCH_CATEGORIES_ERROR("Categories doens't exist."));
          }else{
            dispatch(FETCH_CATEGORIES_ERROR("Try again later."));            
            console.log(error);
          }          
        }
    };
};

